import React from 'react';
import { Tabs, TabList, Tab } from '@chakra-ui/react';
import { localise } from '../../../../services/lang/lang';
import PageHeader from '../../../modules/PageHeader';
import PageContent from '../../../modules/PageContent/PageContent';
import MainLayoutSidebar from '../../../modules/MainLayout/MainLayoutSidebar';
import OrganisationProfile from './OrganisationProfile';
import { PermissionGuardBanner } from '../../../modules/PermissionGuard/PermissionGuardBanner';
import SuspenseWrapper from '../../../modules/SuspenseWrapper/SuspenseWrapper';
const OrganisationProfileWrapper = () => (React.createElement(MainLayoutSidebar, { sidebarSection: "settings", selected: "settings" },
    React.createElement(Tabs, null,
        React.createElement(PageHeader, { title: localise('ORGANISATION_PROFILE') },
            React.createElement(TabList, null,
                React.createElement(Tab, { "data-testid": "organisation_profile__general_tab" }, localise('GENERAL')))),
        React.createElement(SuspenseWrapper, null,
            React.createElement(PageContent, null,
                React.createElement(PermissionGuardBanner, { permissions: ['organisations.update'] }),
                React.createElement(OrganisationProfile, null))))));
export default OrganisationProfileWrapper;
